import React, { useRef, useState } from 'react'
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import AHMIS, { API_URL } from '../../../api/api';
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from '../../../utils/constants';
import AddAlertMessage from '../../../components/alert/Alert';
import ReportHeader from '../component/report-header/ReportHeader';
import MessageBlock from '../../admin/components/message-block/MessageBlock';
import PatientCountCell from '../../../components/patient-count-cell/PatientCountCell';

const YogSewaReport = () => {

  const [tableData, setTableData] = useState();
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo) => {
    const url = `${API_URL.yogSewaReport}?fromDate=${dateFrom}&toDate=${dateTo}`;
    AHMIS.get(url)
      .then(response => {
        const jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setTableData(jsondata.data);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
      });
  };

  return (
    <>
      <ReportHeader
        title="उपचारात्मक योग सेवा रजिष्टर प्रतिवेदन"
        getReportData={getReportData}
        printComponentRef={printComponentRef}
        reportData={Boolean(tableData)}
      />
      {tableData ? (
        <>
          <Box ref={printComponentRef}>
            <TableContainer classes={{ root: "fixed-head-table-container" }}  >
              <Typography variant="body1" className="report-heading">योग सेवा प्रतिवेदन </Typography>
              <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="YOG-Sewa-Report">
                <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                  <TableRow>
                    <TableCell colSpan={2} rowSpan={5}> सेवाको विवरण</TableCell>
                    <TableCell colSpan={5}>उपचारात्मक</TableCell>
                    <TableCell rowSpan={2}>प्रवर्द्धनात्मक</TableCell>
                    <TableCell rowSpan={2}>अभियानमूलक</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>आसन</TableCell>
                    <TableCell>प्राणायाम</TableCell>
                    <TableCell>ध्यान</TableCell>
                    <TableCell>षट्कर्म</TableCell>
                    <TableCell>अन्य </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody classes={{ root: "align-center" }}>
                  <TableRow>
                    <TableCell rowSpan={3}>नयाँ सेवाग्राही संख्या</TableCell>
                    <TableCell>महिला</TableCell>
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["1"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["2"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["3"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["4"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["5"]?.FEMALE} />
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["1"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["2"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["3"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["4"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["5"]?.MALE} />
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["1"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["2"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["3"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["4"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.NEW_PATIENT?.PATIENT_COUNT?.["5"]?.OTHER} />
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={3}>पुनरावृत्त सेवाग्राहीको संख्या</TableCell>
                    <TableCell>महिला</TableCell>
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["1"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["2"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["3"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["4"]?.FEMALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["5"]?.FEMALE} />
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["1"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["2"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["3"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["4"]?.MALE} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["5"]?.MALE} />
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["1"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["2"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["3"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["4"]?.OTHER} />
                    <PatientCountCell data={tableData.upachartmakReport?.PREVIOUS_PATIENT?.PATIENT_COUNT?.["5"]?.OTHER} />
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={3}>नयाँ सेवाग्राही सेवा संख्या</TableCell>
                    <TableCell>महिला</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["1"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["2"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["3"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["4"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["5"]?.FEMALE}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["1"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["2"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["3"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["4"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["5"]?.MALE}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["1"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["2"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["3"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["4"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.NEW_PATIENT?.SERVICE_COUNT?.["5"]?.OTHER}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell rowSpan={3}>पुनरावृत्त सेवाग्राही सेवा संख्या </TableCell>
                    <TableCell>महिला</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["1"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["2"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["3"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["4"]?.FEMALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["5"]?.FEMALE}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>पुरुष</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["1"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["2"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["3"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["4"]?.MALE}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["5"]?.MALE}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>अन्य</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["1"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["2"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["3"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["4"]?.OTHER}</TableCell>
                    <TableCell>{tableData.upachartmakReport?.PREVIOUS_PATIENT?.SERVICE_COUNT?.["5"]?.OTHER}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box mt={2}>
              <TableContainer classes={{ root: "fixed-head-table-container" }}  >
                <Typography variant="body1" className="report-heading">प्रवर्द्धनात्मक तथा अभियानमूलक योग सेवा प्रतिबेदन</Typography>
                <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="yog Sewa">
                  <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                    <TableRow>
                      <TableCell colSpan={2}>सेवाको विवरण</TableCell>
                      <TableCell>प्रवर्द्धधनात्मक</TableCell>
                      <TableCell>अभियानमूलक</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody classes={{ root: "align-center" }}>
                    <TableRow>
                      <TableCell rowSpan={4}>सेवा ग्राही संख्या</TableCell>
                      <TableCell>महिला</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>पुरुष</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>अन्य</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>जम्मा</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell rowSpan={4}>सेवा पटक संख्या</TableCell>
                      <TableCell>महिला</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>पुरुष</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>अन्य</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>जम्मा</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box mt={2}>
              <TableContainer classes={{ root: "fixed-head-table-container" }}  >
                <Typography variant="body1" className="report-heading">उमेर अनुसार योग सेवा प्रतिबेदन</Typography>
                <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="yog Sewa">
                  <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
                    <TableRow>
                      <TableCell>उमेर समूह/सेवा</TableCell>
                      <TableCell>आसन</TableCell>
                      <TableCell>प्रणायाम</TableCell>
                      <TableCell>ध्यान</TableCell>
                      <TableCell>षटकर्म</TableCell>
                      <TableCell>अन्य</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody classes={{ root: "align-center" }}>
                    <TableRow>
                      <TableCell>० देखि ५ वर्ष</TableCell>
                      <PatientCountCell data={tableData?.ageGroupReport?.["0-5"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["0-5"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["0-5"]?.["3"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["0-5"]?.["4"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["0-5"]?.["5"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>६ देखि  १४वर्ष</TableCell>
                      <PatientCountCell data={tableData?.ageGroupReport?.["6-14"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["6-14"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["6-14"]?.["3"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["6-14"]?.["4"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["6-14"]?.["5"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>११ देखि १९माथि</TableCell>
                      <PatientCountCell data={tableData?.ageGroupReport?.["15-19"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["15-19"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["15-19"]?.["3"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["15-19"]?.["4"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["15-19"]?.["5"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>२० देखि ५९माथि</TableCell>
                      <PatientCountCell data={tableData?.ageGroupReport?.["20-59"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["20-59"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["20-59"]?.["3"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["20-59"]?.["4"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["20-59"]?.["5"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>६० देखि ६९माथि</TableCell>
                      <PatientCountCell data={tableData?.ageGroupReport?.["60-69"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["60-69"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["60-69"]?.["3"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["60-69"]?.["4"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.["60-69"]?.["5"]} />
                    </TableRow>
                    <TableRow>
                      <TableCell>≥ ७० बर्ष</TableCell>
                      <PatientCountCell data={tableData?.ageGroupReport?.[">=70"]?.["1"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.[">=70"]?.["2"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.[">=70"]?.["3"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.[">=70"]?.["4"]} />
                      <PatientCountCell data={tableData?.ageGroupReport?.[">=70"]?.["5"]} />
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )}
    </>
  )
}

export default YogSewaReport;
